import api from './index';
//
let exports = {};

// 获取实际收货数量
exports.getRealRecvQuantityByTrackPhaseId = function (postData, callback) {// 获取实际收货数量
    api.post('/goodsDeliv/real/recv/quantity/get/by/trackPhaseId')
    .data(postData)
    .done(callback)
    .go();
};

//查询（商品）收货单列表
exports.getGoodsRecvVoucherList = function (params, callback) {// （商品）退换货/收货单列表
    api.post('/goodsDeliv/recv/voucher/list/get')
    .data(params)
    .done(callback)
    .go();
};

//查询（商品）收货单详情
exports.getGoodsRecvVoucherInfo = function (params, callback) {// （商品）退换货/收货单详情
    api.get('/goodsDeliv/recv/voucher/info/get')
    .params(params)
    .done(callback)
    .go();
};

//冲红发货单
exports.shipVoucherOffset = function (params, callback) {// 确认退换货收货
    api.post('/goodsDeliv/ship/voucher/offset/do')
    .data(params)
    .done(callback)
    .go();
};

//保存收货单
exports.saveGoodsRecvVoucher = function (params, callback) {// 保存退换/收货单
    api.post('/goodsDeliv/recv/voucher/save/do')
    .data(params)
    .done(callback)
    .go();
};

//确认退换货收货
exports.confirmGoodsShipVoucherRecv = function (params, callback) {// 确认退换货收货
    api.post('/goodsDeliv/ship/voucher/recv/confirm/do')
    .params(params)
    .done(callback)
    .go();
};

//获取发货单列表
exports.getGoodsShipVoucherList = function (postData, callback) {// 发货单分页列表
    api.post('/goodsDeliv/ship/voucher/list/get')
    .data(postData)
    .done(callback)
    .go();
};

exports.saveGoodsShipVoucherByAllocForm = function (postData, callback) {// 根据配货单保存发货单
    api.post('/goodsDeliv/ship/voucher/save/do/by/allocForm')
    .data(postData)
    .done(callback)
    .go();
};

//获取发货单详情
exports.getGoodsShipVoucherInfo = function (params, callback) {// 发货单详情
    api.get('/goodsDeliv/ship/voucher/info/get')
    .params(params)
    .done(callback)
    .go();
};

exports.confirmGoodsShipVoucher = function (params, callback) {// 确认发货
    api.post('/goodsDeliv/ship/voucher/confirm/do')
    .params(params)
    .done(callback)
    .go();
};

exports.invalidGoodsShipVoucher = function (postData, callback) {// 作废商品发货单
    api.post('/goodsDeliv/ship/voucher/invalid/do')
    .data(postData)
    .done(callback)
    .go();
};

//委托请求发送
exports.doGoodsShipVoucherReqSend = function (postData, callback) {
    api.post('/goodsDeliv/ship/voucher/req/send')
    .data(postData)
    .done(callback)
    .go();
};
//委托请求响应(受托方操作)
exports.doGoodsShipVoucherReqResponse = function (postData, callback) {
    api.post('/goodsDeliv/ship/voucher/req/response')
    .data(postData)
    .done(callback)
    .go();
};
// ====================== 供商编码 ===========================

// 查询所有供商编码
exports.getMerchtGoodsUknoList = function (params, callback) {// 查询所有供商编码
    api.post('/goodsDeliv/mercht/goods/ukno/list/get')
    .data(params)
    .done(callback)
    .go();
};
// 新增编码
exports.saveMerchtGoodsUkno = function (params, callback) {// 新增编码
    api.post('/goodsDeliv/mercht/goods/ukno/save/do')
    .data(params)
    .done(callback)
    .go();
};
// 上传编码
exports.doMerchtGoodsUknoImport = function (params, callback) {// 新增编码
    api.post('/goodsDeliv/mercht/goods/ukno/import/do')
    .data(params)
    .done(callback)
    .go();
};

// 上传编码
exports.saveMerchtGoodsUknoParamsForExport = function (params, callback) {// 新增编码
    api.post('/goodsDeliv/ukno/params/for/export/url')
    .data(params)
    .done(callback)
    .go();
};
exports.saveMerchtGoodsUknoModelForExport = function (params, callback) {// 新增编码
    api.post('/goodsDeliv/ukno/model/for/export/url')
    .data(params)
    .done(callback)
    .go();
};
// 作废商品标识码
exports.doMerchtGoodsUKnoInvalid = function (params, callback) {
    api.post('/goodsDeliv/mercht/goods/ukno/invalid/do')
    .data(params)
    .done(callback)
    .go();
};
// 删除商品标识码
exports.doMerchtGoodsUKnoDelete = function (params, callback) {
    api.post('/goodsDeliv/mercht/goods/ukno/delete/do')
    .data(params)
    .done(callback)
    .go();
};
// 商品标识码-关联买家/解除买家
exports.updateMerchtGoodsUknoRetailerInfo = function (params, callback) {
    api.post('/goodsDeliv/mercht/goods/ukno/retailer/update/do')
    .data(params)
    .done(callback)
    .go();
};
// 查询商品标识码使用记录
exports.getMerchtGoodsUknoRecList = function (params, callback) {
    api.post('/goodsDeliv/mercht/goods/ukno/rec/list/get')
    .data(params)
    .done(callback)
    .go();
};
//
export default exports;



//////////////////
// WEBPACK FOOTER
// ./src/api/goodsDeliv.js
// module id = 66
// module chunks = 1